<template>
  <div>
    <v-container>
      <v-layout row wrap>
        <v-flex xs2>
          <div class="form-control">
            <label>Start date</label>
            <DatepickerCustomDialog @input="onChangeDate" v-model="selectedDate.start">
              <input readonly :value="getDateFormated(selectedDate.start)" type="text" />
            </DatepickerCustomDialog></div
        ></v-flex>
        <v-flex xs2 class="ml-2">
          <div class="form-control">
            <label>End date</label>
            <DatepickerCustomDialog @input="onChangeDate" v-model="selectedDate.end">
              <input readonly :value="getDateFormated(selectedDate.end)" type="text" />
            </DatepickerCustomDialog></div
        ></v-flex>
      </v-layout>
      <div>
        <v-layout row wrap>
          <v-flex xs7 class="mb-4">
            <div class="primary--text mb-2" style="font-size: 22px">เลือกกลุ่ม</div>
            <multiselect
              :loading="pageloading"
              @input="onChangeGroup"
              placeholder="เลือกกลุ่ม"
              label="name"
              v-model="input.group"
              :show-labels="false"
              :options="groupOptions"
            ></multiselect>
          </v-flex>
          <v-flex xs7>
            <div class="primary--text mb-2" style="font-size: 22px">เลือกเพจ</div>
            <multiselect
              :loading="pageloading"
              @input="onChangePage"
              placeholder="เลือกเพจ"
              label="channelname"
              v-model="input.channels"
              :show-labels="false"
              :options="filteredChannel"
            ></multiselect>
          </v-flex>
          <v-flex xs8>
            <div class="primary--text mb-2 mt-4" style="font-size: 22px">เลือกโพสต์</div>

            <multiselect
              @input="onChangePost"
              :loading="postloading"
              placeholder="เลือกโพสต์"
              label="topic"
              v-model="input.post"
              :show-labels="false"
              :options="postdata"
            ></multiselect>
          </v-flex>
        </v-layout>
        <div v-if="postloading" class="text-xs-center mt-5">
          <v-progress-circular indeterminate color="primary" size="60"></v-progress-circular>
        </div>
        <div v-else-if="input.channels || input.group || input.post" class="px-3">
          <v-divider class="mt-4"></v-divider>
          <div class="my-4" style="font-weight: bold; color: grey; font-size: 22px">
            Facebook post Impression
          </div>
          <v-layout row wrap class="ma-0">
            <v-flex xs4 class="px-2">
              <v-card>
                <div class="px-4 pt-4 text-xs-center pb-0">
                  <span style="font-size: 33px; color: #258bd3">
                    <span v-if="likeCountLoading"
                      ><v-progress-circular indeterminate color="primary"></v-progress-circular
                    ></span>
                    <span v-else>{{ likeCount }}</span>
                  </span>
                </div>
                <div
                  class="pa-2 text-xs-center white--text"
                  style="background-color: #258bd3; font-size: 23px"
                >
                  <em class="fas fa-thumbs-up pr-2" /> LIKE
                </div>
              </v-card>
            </v-flex>
            <v-flex xs4 class="px-2">
              <v-card>
                <div class="px-4 pt-4 text-xs-center pb-0">
                  <span style="font-size: 33px; color: #258bd3">
                    <span v-if="commentCountLoading"
                      ><v-progress-circular indeterminate color="primary"></v-progress-circular
                    ></span>
                    <span v-else>{{ commentCount }}</span>
                  </span>
                </div>
                <div
                  class="pa-2 text-xs-center white--text"
                  style="background-color: #258bd3; font-size: 23px"
                >
                  <em class="fas fa-comment pr-2" /> COMMENT
                </div>
              </v-card>
            </v-flex>
            <v-flex xs4 class="px-2">
              <v-card>
                <div class="px-4 pt-4 text-xs-center pb-0">
                  <span style="font-size: 33px; color: #258bd3">
                    <span v-if="shareCountLoading"
                      ><v-progress-circular indeterminate color="primary"></v-progress-circular
                    ></span>
                    <span v-else>{{ shareCount }}</span>
                  </span>
                </div>
                <div
                  class="pa-2 text-xs-center white--text"
                  style="background-color: #258bd3; font-size: 23px"
                >
                  <em class="fas fa-share pr-2" /> SHARE
                </div>
              </v-card>
            </v-flex>
          </v-layout>
        </div>

        <div v-if="!postloading && postdata.length > 0" class="mt-4">
          <div class="topic-box" v-for="p in postdata" :key="p.id">
            <div>
              {{ p.topic }}
            </div>
            <div class="d-flex mt-2">
              <div class="count-box mr-2 p-2">
                <span v-if="p.like.loading"
                  ><v-progress-circular indeterminate color="primary"></v-progress-circular
                ></span>
                <span v-else class="text-center">
                  <p>Like</p>
                  <p>{{ p.like.count }}</p>
                </span>
              </div>
              <div class="count-box mr-2 p-2">
                <span v-if="p.comment.loading"
                  ><v-progress-circular indeterminate color="primary"></v-progress-circular
                ></span>
                <span v-else class="text-center">
                  <p>Comment</p>
                  <p>{{ p.comment.count }}</p>
                </span>
              </div>
              <div class="count-box p-2">
                <span v-if="p.share.loading"
                  ><v-progress-circular indeterminate color="primary"></v-progress-circular
                ></span>
                <span v-else class="text-center">
                  <p>Share</p>
                  <p>{{ p.share.count }}</p>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </v-container>
  </div>
</template>

<script>
import api from '@/api'
import multiselect from 'vue-multiselect'
import { mapGetters } from 'vuex'
import DatepickerCustomDialog from '@/components/elements/DatepickerCustomDialog.vue'
import moment from 'moment'

export default {
  props: ['channels', 'pageloading', 'groupOptions'],
  components: {
    multiselect,
    DatepickerCustomDialog
  },
  data() {
    return {
      commentdata: [],
      likedata: [],
      sharedata: [],
      allpostdata: [],
      data: [],
      postdata: { name: '' },
      loading: false,
      postloading: false,
      showSelectPost: false,
      intentpostidlist: '',
      selectedDate: {
        start: moment().format('YYYY-MM-DD'),
        end: moment().format('YYYY-MM-DD')
      },
      input: {
        group: '',
        channels: '',
        post: '',
        topic: ''
      },
      postdata: [],
      posts: [],
      likeCount: 0,
      commentCount: 0,
      shareCount: 0
    }
  },
  computed: {
    alltopic() {
      if (this.input.group || this.input.channels) {
        var tempdata = []
        return this.likedata.filter((el) => {
          if (tempdata.includes(el.topic)) {
            return false
          } else {
            tempdata.push(el.topic)
            return true
          }
        })
      } else return this.allpostdata
    },
    allLikes() {
      var result = 0
      if (this.likedata && this.likedata.length) {
        var data = [...this.likedata]
        // if (this.input.post) {
        //   data = data.filter((el) => el.postid == this.input.post.postid)
        // }

        result = data.reduce((acc, cur) => {
          return acc + cur.likecount
        }, 0)
      }
      return result
    },
    allComments() {
      var result = 0
      if (this.commentdata && this.commentdata.length) {
        var data = [...this.commentdata]
        if (this.input.post) {
          data = data.filter((el) => el.postid == this.input.post.postid)
        }
        result = data.reduce((acc, cur) => {
          return acc + cur.commentcount
        }, 0)
      }
      return result
    },
    allShares() {
      var result = 0
      if (this.sharedata && this.sharedata.length) {
        var data = [...this.sharedata]
        if (this.input.post) {
          data = data.filter((el) => el.postid == this.input.post.postid)
        }
        result = data.reduce((acc, cur) => {
          return acc + cur.sharecount
        }, 0)
      }
      return result
    },
    filteredChannel() {
      var result = this.channels.filter((el) => el.app == 'facebook')
      if (this.input.group) {
        result = result.filter((el) =>
          el.groupids ? el.groupids.includes(parseInt(this.input.group.id)) : false
        )
      }
      return result
    },
    ...mapGetters(['selectedBot']),
    likeCountLoading() {
      let result = this.postdata.filter((f) => f.like.loading == true)
      if (result.length > 0) {
        return true
      } else {
        return false
      }
    },
    commentCountLoading() {
      let result = this.postdata.filter((f) => f.comment.loading == true)
      if (result.length > 0) {
        return true
      } else {
        return false
      }
    },
    shareCountLoading() {
      let result = this.postdata.filter((f) => f.share.loading == true)
      if (result.length > 0) {
        return true
      } else {
        return false
      }
    }
  },
  mounted() {
    this.getAllpostData()
  },
  methods: {
    getAllpostData() {
      var data = {
        pageid: this.selectedBot.pageid
        // dateTo: this.selectedDate.start, // YYYY-MM-DD
        // dateFrom: this.selectedDate.end, // YYYY-MM-DD
      }

      api.getPowerbuyFacebookPost(data, (err, response) => {
        this.allpostdata = response.data
      })
    },
    async onChangeDate() {
      if (this.input.channels || this.input.group || this.input.post) {
        await this.getData()
      }
    },
    async onChangeGroup() {
      this.input.channels = ''
      this.input.post = ''
      this.input.topic = ''
      await this.getData()
    },
    async onChangePost(val) {
      if (!this.input.channels || !this.input.group) {
        this.input.topic = val.topic
        await this.getData()
      }
    },
    async getData(topic) {
      if (this.input.channels || this.input.group || this.input.topic) {
        var data = {
          pageid: this.selectedBot.pageid
        }
        if (this.input.channels && this.input.channels.channelid) {
          Object.assign(data, { channelId: this.input.channels.channelid })
        }
        if (this.input.group.id && !this.input.channels) {
          Object.assign(data, { groupId: this.input.group.id })
        }
        if (this.input.topic) {
          Object.assign(data, { topic: this.input.topic })
        }

        if (this.selectedDate.start) {
          data.dateFrom = moment(this.selectedDate.start).format('YYYY-MM-DD')
        }
        if (this.selectedDate.end) {
          data.dateTo = moment(this.selectedDate.end).format('YYYY-MM-DD')
        }

        this.postdata = []
        this.likeCount = 0
        this.commentCount = 0
        this.shareCount = 0

        this.postloading = true
        let response = await api.getPowerbuyFacebookImpressionPostDetail(data)
        this.postdata = response.data
        this.postdata = this.postdata.map((p) => {
          return {
            admin: p.admin,
            id: p.id,
            postid: p.postid,
            page_access_token: p.page_access_token,
            pageid: p.pageid,
            photoid: p.photoid,
            timestamp: p.timestamp,
            topic: p.topic,
            total: p.total,
            like: {
              count: null,
              loading: true
            },
            comment: {
              count: null,
              loading: true
            },
            share: {
              count: null,
              loading: true
            }
          }
        })
        await this.getFacebookDataDetail()

        // Old logic
        // Promise.all([
        //   api.getPowerbuyFacebookComment(data),
        //   api.getPowerbuyFacebookLike(data),
        //   api.getPowerbuyFacebookShare(data),
        // ]).then((response) => {
        //   this.commentdata = response[0].data
        //   this.likedata = response[1].data
        //   this.sharedata = response[2].data
        //   this.postloading = false
        // })
      } else {
        this.commentdata = []
        this.likedata = []
        this.sharedata = []
      }
      // api.getPowerbuyFacebookImpression(data, (err, response) => {
      //   this.postloading = false
      //   if (response.responsecode == 200) {
      //     this.data = response.data
      //   }
      // })
    },
    async getFacebookDataDetail() {
      this.postloading = true
      this.postdata.forEach(async (p) => {
        let params = { access_token: p.page_access_token, summary: 'total_count' }
        p.like.loading = true
        let like = await api.getFacebookReactionsByPostId(p.postid, params)
        this.likedata = [...this.likedata, ...like.data]
        let lLike = like.summary ? like.summary.total_count : 0
        this.likeCount += lLike
        p.like.count = lLike
        p.like.loading = false

        p.comment.loading = true
        let comment = await api.getFacebookCommentByPostId(p.postid, params)
        this.commentdata = [...this.commentdata, ...comment.data]
        let lComment = comment.summary ? comment.summary.total_count : 0
        this.commentCount += lComment
        p.comment.count = lComment
        p.comment.loading = false

        p.share.loading = true
        params = { access_token: p.page_access_token, fields: 'shares' }
        let share = await api.getFacebookPostByPostId(p.postid, params)
        let lShare = share.shares ? share.shares.count : 0
        this.shareCount += lShare
        p.share.count = lShare
        p.share.loading = lShare
      })
      this.postloading = false
    },
    onChangePage(val) {
      this.input.topic = ''
      this.input.post = ''
      this.getData()
    },
    getDateFormated(val) {
      if (val) {
        return moment(val).format('DD/MM/YYYY')
      } else return ''
    }
  }
}
</script>

<style lang="scss" scoped>
.topic-box {
  border: 1px solid black;
  padding: 10px;
  border-radius: 5px;
  margin-bottom: 10px;
  color: black;
}

.count-box {
  border: 1px solid black;
  padding: 10px;
  border-radius: 5px;
  margin-bottom: 10px;
  width: 88px;
  height: 80px;
  color: black !important;
}
</style>



// WEBPACK FOOTER //
// src/components/view/template/powerbuy/Analytics/ImpressionFacebook.vue